import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API;

const Listdelete = ({ increment, counter, setCounter }) => {
  const [mayors, setMayors] = useState(null);
  const [mayorId, setMayorId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get("/jobs/mayor/", {
          signal: controller.signal,
        });

        isMounted &&
          setMayors(response.data.sort((a, b) => (a.id < b.id ? 1 : -1)));
        console.log(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);
  const handleEditClick = (event, mayor) => {
    event.preventDefault();
    setMayorId(mayor.id);
  };
  const handleCancelClick = () => {
    setMayorId(null);
  };

  if (!mayors) return null;
  return (
    <>
      <div className="mx-auto">
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <form onSubmit={increment}>
              <Table hover>
                <thead>
                  <tr>
                    <th>שם מלא</th>
                    <th>שם מלא בערבית</th>
                    <th>תאריך התחלת תקופה</th>
                    <th>תאריך סיום תקופה</th>
                    <th>פעיל</th>
                  </tr>
                </thead>
                <tbody>
                  {mayors?.map((mayor) => (
                    <Fragment key={mayor.id}>
                      {mayorId === mayor.id ? (
                        <Edit
                          mayor={mayor}
                          handleCancelClick={handleCancelClick}
                          increment={increment}
                          counter={counter}
                          setMayorId={setMayorId}
                        />
                      ) : (
                        <ReadOnlyRows
                          mayor={mayor}
                          handleEditClick={handleEditClick}
                          increment={increment}
                          setMayorId={setMayorId}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                        />
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
      </div>

      <ErrorModal
        showError={showError}
        setShowError={setShowError}
        errorMessage={errorMessage}
        errorHeader={errorHeader}
      />
    </>
  );
};
export default Listdelete;

const ReadOnlyRows = ({
  mayor,
  handleEditClick,
  setMayorId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת מחלקת "${mayor.full_name}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "jobs/mayor/" + mayor.id,
          {
            signal: controller.signal,
          }
        );

        if (isMounted) {
          increment();
        }
      } catch (err) {
        if (err.response) {
          alert(
            "ישנם מכרזים מקושרים לראש העיר או " +
              HandleHttpErrors(err.response.status)
          );
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors("22222", err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
    setMayorId(null);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={mayor.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{mayor.full_name}</td>
        <td>{mayor.full_name_arb}</td>
        <td>{mayor.start_date}</td>
        <td>{mayor.end_date}</td>
        <td>{mayor.active ? "כן" : "לא"}</td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, mayor)}
          >
            <FiEdit2 />
          </button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("mayor", mayor.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
